import React from 'react';

import { ShopScreen } from 'features/shop-base/ShopScreen';
import { withAuth } from 'features/auth/components/withAuth';

const ArchivedCardScreen = withAuth()(() => (
    <ShopScreen>
        <h1>Archived Cards</h1>
    </ShopScreen>
));

export default ArchivedCardScreen;
